import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import argoCDPlugin from '@roadiehq/backstage-plugin-argo-cd/alpha';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import { SignInPageBlueprint, ThemeBlueprint } from '@backstage/plugin-app-react';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';
import { UnifiedThemeProvider } from '@backstage/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { scgroupsTheme } from './theme/scgroupsTheme';

// Without this, the app defaults to an implicit guest auto-login, which
// fails loudly since app-config.production.yaml only configures the
// `github` provider (no `guest`).
const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () =>
      props => (
        <SignInPage
          {...props}
          provider={{
            id: 'github-auth-provider',
            title: 'GitHub',
            message: 'Sign in using your SCGROUPS GitHub account',
            apiRef: githubAuthApiRef,
          }}
        />
      ),
  },
});

const scgroupsThemeExtension = ThemeBlueprint.make({
  name: 'scgroups',
  params: {
    theme: {
      id: 'scgroups',
      title: 'SCGROUPS',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={scgroupsTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export default createApp({
  features: [
    catalogPlugin,
    kubernetesPlugin,
    argoCDPlugin,
    githubActionsPlugin,
    navModule,
    homeModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage, scgroupsThemeExtension],
    }),
  ],
});
